import { CommonModule, DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AirportLookupModule } from '../common/airport-lookup/airport-lookup.module';
import { AlertAdvisoriesModule } from '../common/alert-advisories/alert-advisories.module';
import { NgcCommonModule } from '../common/common.module';
import { DateSelectionModule } from '../common/date-selection/date-selection.module';
import { LanguageSelectorModule } from '../common/language-selector/language-selector.module';
import { ScrollModule } from '../common/scroll-directive/scroll.module';
import { UnsupportedBrowserComponent } from '../common/unsupported-browser/unsupported-browser.component';
import { UnsupportedBrowserModule } from '../common/unsupported-browser/unsupported-browser.module';
import { FlyoutLangSelectConfirmationComponent } from '../flyout/flyout-lang-select-confirmation/flyout-lang-select-confirmation.component';
import { FlyoutLangSelectConfirmationModule } from '../flyout/flyout-lang-select-confirmation/flyout-lang-select-confirmation.module';
import { FlyoutModule } from '../flyout/flyout.module';
import { SEOModule } from '../seo/seo-module';
import { TranslatedsitesLangService } from '../services/translatedsites/translatedsiteslang.service';
import { NgcStoreModule } from '../store/store.module';
import { AppLinksContentMobileContainerModule } from './app-links-content-mobile-container/app-links-content-mobile-container.module';
import { AppNavigationLinksModule } from './app-navigation-links/app-navigation-links.module';
import { AppSecondaryLinksContentModule } from './app-secondary-links-content/app-secondary-links-content.module';
import { BusinessUserModule } from './business-user/business-user.module';
import { NgcSlimHeaderModule } from './global-nav-slim/global-nav-slim.module';
import { NgcGlobalNav } from './global-nav.component';
import { LoginModule } from './login/login.module';
import { LogoModule } from './logo/logo.module';
import { MobileWidgetModalComponent } from './mobile-widget/mobile-widget-modal.component';
import { MobileWidgetComponent } from './mobile-widget/mobile-widget.component';
import { MyTripsLinkComponent } from './my-trips-link/my-trips-link.component';
import { NavigationBookModule } from './navigation-book/navigation-book.module';
import { NavigationCheckinModule } from './navigation-checkin/navigation-checkin.module';
import { NavigationFlightStatusModule } from './navigation-flight-status/navigation-flight-status.module';
import { NavigationMytripsModule } from './navigation-mytrips/navigation-mytrips.module';
import { NotificationModule } from './notification/notification.module';
import { SearchModule } from './search/search.module';
import { SwitchingAccountModule } from './switching-account/switching-account.module';

const NGC_HEADER_DIRECTIVES = [
  NgcGlobalNav,
  MobileWidgetComponent,
  MobileWidgetModalComponent,
  MyTripsLinkComponent
];

@NgModule({ declarations: [NGC_HEADER_DIRECTIVES],
    exports: [NGC_HEADER_DIRECTIVES],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [NgcCommonModule,
        CommonModule,
        FlyoutModule,
        LogoModule,
        LoginModule,
        ScrollModule,
        NavigationBookModule,
        NavigationCheckinModule,
        NavigationMytripsModule,
        NavigationFlightStatusModule,
        AppSecondaryLinksContentModule,
        AppNavigationLinksModule,
        NotificationModule,
        SearchModule,
        AppLinksContentMobileContainerModule,
        DateSelectionModule,
        DateSelectionModule,
        AirportLookupModule,
        AlertAdvisoriesModule,
        ModalModule.forRoot(),
        LanguageSelectorModule,
        NgcStoreModule,
        FormsModule,
        ReactiveFormsModule,
        UnsupportedBrowserModule,
        FlyoutLangSelectConfirmationModule,
        BusinessUserModule,
        SwitchingAccountModule,
        SEOModule,
        NgcSlimHeaderModule], providers: [DatePipe, TranslatedsitesLangService, provideHttpClient(withInterceptorsFromDi())] })
export class NgcHeaderModule {}
